export const dueDateChecker = (docDate, term) => {
  let getDue = new Date(docDate)
  return getDue.setDate(getDue.getDate() + Number(term))
}
